var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMenuChat = function SvgMenuChat(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.342C0 1.031 1.122 0 2.465 0h10.26c1.342 0 2.465 1.03 2.465 2.342v.879h2.345c1.343 0 2.465 1.03 2.465 2.342v11.99a.447.447 0 0 1-.282.414.46.46 0 0 1-.497-.1l-3.427-3.433a1.616 1.616 0 0 0-1.102-.426H7.491c-1.343 0-2.465-1.031-2.465-2.342v-.084c-.313.053-.6.195-.825.407l-.01.009-3.432 3.045a.46.46 0 0 1-.49.076A.447.447 0 0 1 0 14.71V2.342Zm5.935 9.216v.107c0 .782.678 1.448 1.556 1.448h7.201c.647 0 1.272.242 1.736.68l.01.009 2.653 2.657V5.563c0-.781-.678-1.447-1.556-1.447H15.19v5.1c0 1.311-1.123 2.342-2.465 2.342h-6.79ZM2.465.895C1.587.895.909 1.56.909 2.342v11.363l2.668-2.367a2.533 2.533 0 0 1 1.731-.675h7.417c.878 0 1.556-.666 1.556-1.447V2.342c0-.781-.678-1.447-1.556-1.447H2.465Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "9cb6cb9193d0dbb6a00b059ca2661e33.svg";